<template>
  <div id="app">
    <v-header></v-header>

    <b-container fluid>
      <router-view></router-view>
    </b-container>
  </div>

</template>

<script>
import Header from '@/components/layout/Header';

export default {
  name: 'app',
  components: {
    'v-header': Header,
  },
};
</script>

<style lang="scss">
  #app {
    margin: {
      top: 70px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue